<form #form="ngForm" class="form-validate">
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <label class="col-form-label col-auto">
          ลงทะเบียนแบบกลุ่ม
        </label>
      </div>
      <hr>
      <div class="row mb-3">
        <div class=" col-xl-12">
          <label class="ui-require"><strong>ไฟล์นำเข้าข้อมูลการลงทะเบียน</strong></label>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <a role="button" class="btn-link text-decoration-none">
            <i class="bi bi-paperclip me-2"></i>
            ดาวน์โหลด template
          </a>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 mt-2 mb-2">
          <app-file-upload id="file1"></app-file-upload>
        </div>
      </div>
    </div>
  </div>
  <div class="card custom-box mt-3">
    <div class="card-header">
      <p class="ms-2 pt-3">จำนวนทั้งหมด 0 รายการ</p>
      <div class="ms-2 d-inline-block" style="top: 10px;">
        จำนวนที่ไม่ผ่านทั้งหมด 0 รายการ
      </div>
      <button type="button"
              class="btn btn-danger float-end">
        <i class="bi bi-database me-2"></i>ดาวน์โหลดรายละเอียด
      </button>
    </div>
    <div class="row mb-3">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="text-center">
          <tr>
            <th scope="col" class="align-middle" nowrap>ลำดับ</th>
            <th scope="col" class="align-middle bg-warning" nowrap>เหตุผล</th>
            <th scope="col" class="align-middle bg-info-subtle" nowrap>เลขประจำตัวประชาชน</th>
            <th scope="col" class="align-middle bg-info-subtle" nowrap>ชื่อ - สกุล</th>
            <th scope="col" class="align-middle bg-info-subtle" nowrap>สิทธิการรักษาพยาบาล (ปัจจุบัน)</th>
            <th scope="col" class="align-middle bg-info-subtle" nowrap>โรงพยาบาลรับรักษา (ปัจจุบัน)</th>
            <th scope="col" class="align-middle bg-success" nowrap>สิทธิการรักษาพยาบาล (ล่วงหน้า)</th>
            <th scope="col" class="align-middle bg-success" nowrap>ประเภทสิทธิย่อย/สิทธิที่ใช้เบิก (ล่วงหน้า)</th>
            <th scope="col" class="align-middle bg-success" nowrap>เพศ</th>
            <th scope="col" class="align-middle bg-success" nowrap>อายุ</th>
            <th scope="col" class="align-middle bg-success" nowrap>สถานะสิทธิประกันสุขภาพ</th>
          </tr>
          </thead>
          <tbody>
          <td colspan="11">
            <app-not-found></app-not-found>
          </td>
          </tbody>
        </table>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <ngb-pagination class="d-flex justify-content-center"
                          [maxSize]="5"
                          [rotate]="true"
                          [ellipses]="false"
                          [boundaryLinks]="true"
                          [page]="pageData?.number + 1"
                          (pageChange)="search($event)"
                          [pageSize]="pageData?.size"
                          [collectionSize]="pageData?.totalElements"></ngb-pagination>
        </div>
      </div>
    </div>
    <div class="card-header mt-3">
      <div class="d-inline-block" style="top: 10px;">
        จำนวนที่ผ่าน แต่ระบบตรวจสอบพบความผิดปกติของข้อมูล กรุณาตรวจสอบข้อมูลอีกครั้ง 0 รายการ
      </div>
      <button type="button" class="btn btn-danger float-end">
        <i class="bi bi-database me-2"></i>ดาวน์โหลดรายละเอียด
      </button>
    </div>
    <div class="row mb-3">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="text-center">
          <tr>
            <th scope="col" class="align-middle" nowrap>ลำดับ</th>
            <th scope="col" class="align-middle" nowrap>เลขประจำตัวประชาชน</th>
            <th scope="col" class="align-middle" nowrap>ชื่อ - สกุล</th>
            <th scope="col" class="align-middle" nowrap>ประเภทสิทธิย่อย/สิทธิที่ขอเบิกใหม่</th>
            <th scope="col" class="align-middle" nowrap>วันที่หมดอายุสิทธิใหม่</th>
            <th scope="col" class="align-middle" nowrap>สิทธิการรักษาพยาบาล</th>
            <th scope="col" class="align-middle" nowrap>ประเภทสิทธิย่อย/สิทธิที่ใช้เบิก</th>
            <th scope="col" class="align-middle" nowrap>จังหวัดที่ลงทะเบียนใหม่</th>
            <th scope="col" class="align-middle" nowrap>หน่วยบริการปฐมภูมิใหม่</th>
            <th scope="col" class="align-middle" nowrap>หน่วยบริการที่รับส่งต่อใหม่</th>
            <th scope="col" class="align-middle" nowrap>หน่วยบริการประจำใหม่</th>
          </tr>
          </thead>
          <tbody>
          <td colspan="11">
            <app-not-found></app-not-found>
          </td>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <ngb-pagination class="d-flex justify-content-center"
                        [maxSize]="5"
                        [rotate]="true"
                        [ellipses]="false"
                        [boundaryLinks]="true"
                        [page]="pageData?.number + 1"
                        (pageChange)="search($event)"
                        [pageSize]="pageData?.size"
                        [collectionSize]="pageData?.totalElements"></ngb-pagination>
      </div>
    </div>
    <div class="card-header">
      <div class="d-inline-block" style="top: 10px;">
        จำนวนที่ผ่าน 0 รายการ
      </div>
      <button type="button" class="btn btn-danger float-end">
        <i class="bi bi-database me-2"></i>ดาวน์โหลดรายละเอียด
      </button>
    </div>
    <div class="row mb-3">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="text-center">
          <tr>
            <th scope="col" class="align-middle" nowrap>ลำดับ</th>
            <th scope="col" class="align-middle" nowrap>เลขประจำตัวประชาชน</th>
            <th scope="col" class="align-middle" nowrap>ชื่อ - สกุล</th>
            <th scope="col" class="align-middle" nowrap>ประเภทสิทธิย่อย/สิทธิที่ขอเบิกใหม่</th>
            <th scope="col" class="align-middle" nowrap>วันที่หมดอายุสิทธิใหม่</th>
            <th scope="col" class="align-middle" nowrap>สิทธิการรักษาพยาบาล</th>
            <th scope="col" class="align-middle" nowrap>ประเภทสิทธิย่อย/สิทธิที่ใช้เบิก</th>
            <th scope="col" class="align-middle" nowrap>จังหวัดที่ลงทะเบียนใหม่</th>
            <th scope="col" class="align-middle" nowrap>หน่วยบริการปฐมภูมิใหม่</th>
            <th scope="col" class="align-middle" nowrap>หน่วยบริการที่รับส่งต่อใหม่</th>
            <th scope="col" class="align-middle" nowrap>หน่วยบริการประจำใหม่</th>
          </tr>
          </thead>
          <tbody>
          <td colspan="11">
            <app-not-found></app-not-found>
          </td>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <ngb-pagination class="d-flex justify-content-center"
                        [maxSize]="5"
                        [rotate]="true"
                        [ellipses]="false"
                        [boundaryLinks]="true"
                        [page]="pageData?.number + 1"
                        (pageChange)="search($event)"
                        [pageSize]="pageData?.size"
                        [collectionSize]="pageData?.totalElements"></ngb-pagination>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-xl-12 text-center">
          <button type="submit" class="btn btn-success app-btn me-3">ยืนยันการลงทะเบียน</button>
        </div>
      </div>
    </div>
  </div>
</form>
